import React from 'react';
import {connect} from 'react-redux';
import strings from 'utils/strings';

import AudioPlayer from 'components/AudioPlayer';
import audioNo from '../../assets/sounds/adult/sprakforslesaSounds/no/Introduksjon-sprakforstaelse.mp3';
import audioNn from '../../assets/sounds/adult/sprakforslesaSounds/nn/Introduksjon-sprakforstaelse.mp3';

const languageObj = {
	no: audioNo,
	nn: audioNn,
};

class Intro extends React.Component {
	constructor(props) {
		super(props);
		this.audio = languageObj[strings.getLanguage()];
	}

	render() {
		const {onNextStep} = this.props;

		return (
			<div>
				<p>
					<AudioPlayer
						onErrorPlay={() => {
							console.log('Something went wrong');
						}}
						autoplay
						inline
						src={this.audio}
					/>
					{strings.sprakforstaelseIntro}
				</p>
				<button
					className="lit-btn bg-primary"
					onClick={() => {
						onNextStep();
					}}
				>
					{strings.toPractice}
				</button>
			</div>
		);
	}
}

const mapStateToProps = () => {
	return {};
};

export default connect(mapStateToProps)(Intro);
